<div class="mdl-grid">
  <div class="mdl-cell mdl-cell--4-col"></div>
  <div class="mdl-cell mdl-cell--4-col">
    <vs-forgot-password (onSend)="sendInstructions($event)" [loading]="loading"></vs-forgot-password>
  </div>
  <div class="mdl-cell mdl-cell--4-col"></div>
</div>
